import { request } from '../request'

export function find(id) {
  return request(`/dealers/${id}.json`)
}

export function search(query) {
  return request(`/dealers.json?query=${query}`)
}
